import { flowReducer } from './flowReducer'
import { orgSelectReducer } from './orgSelectReducer'
import { positionReducer } from './positionReducer'

export default {
  flow: flowReducer,
  orgSelect: orgSelectReducer,
  position: positionReducer,
}
